import { Col } from "antd";
import GroupTripsMap from "../groupTripsMap/groupTripsMap";
import AdminTrip from "./adminTrip";
import ContainerLayout from "../../common/containerLayout";

const TripsGroup = (): JSX.Element => {
  return (
    <ContainerLayout title="Viajes en grupo">
      <Col span={14}>
        <AdminTrip />
      </Col>
      <Col span={10}>
        <GroupTripsMap margin="" />
      </Col>
    </ContainerLayout>
  );
};

export default TripsGroup;
